import { useState, useEffect } from "react";
import {
    PayPalScriptProvider,
    BraintreePayPalButtons,
    usePayPalScriptReducer
} from "@paypal/react-paypal-js";
import React from 'react'
import { API_HOST } from './../../constants/server.constant';
// This values are the props in the UI
const style = {"label":"paypal","layout":"vertical"};
//const amount = 10;
// Custom component to wrap the PayPalButtons and handle currency changes
/*const ButtonWrapper = ({ currency }) => {
    // usePayPalScriptReducer can be use only inside children of PayPalScriptProviders
    // This is the main reason to wrap the PayPalButtons in a new component
    const [{ options, isPending }, dispatch] = usePayPalScriptReducer();

    useEffect(() => {
        dispatch({
            type: "resetOptions",
            value: {
                ...options,
                currency: currency,
            },
        });
    }, [currency]);

    return (<BraintreePayPalButtons
        style={style}
        disabled={false}
        fundingSource="" // Available values are: ["paypal", "card", "credit", "paylater", "venmo"]
        forceReRender={[style, amount]}
        createOrder={function (data, actions) {
            return actions.braintree
                .createPayment({
                    flow: "checkout",
                    amount: amount, // Here change the amount if needed
                    currency: "USD", // Here change the currency if needed
                    intent: "capture",
                    enableShippingAddress: true,
                    shippingAddressEditable: false,
                    shippingAddressOverride: {
                        recipientName: "Scruff McGruff",
                        line1: "1234 Main St.",
                        line2: "Unit 1",
                        city: "Chicago",
                        countryCode: "US",
                        postalCode: "60652",
                        state: "IL",
                        phone: "123.456.7890",
                    },
                })
                .then((orderId) => {
                    // Your code here after create the order
                    return orderId;
                });
        }}
        onApprove={function (data, actions) {
            return actions.braintree
                .tokenizePayment(data)
                .then((payload) => {
                    // Your code here after capture the order
                    console.log(JSON.stringify(payload));
                });
            }
        }
    />);
};*/

export default function Dummy() {

    const [clientToken, setClientToken] = useState(null);
    const [customerId, setCustomerId] = useState(null);


    useEffect(() => {
        async function fetchMyAPI() {
            await fetch(API_HOST+"/pm/clientToken",{headers : { 
                'Content-Type': 'application/json',
                'Accept': 'application/json'
               }})
               .then(resp=>resp.text())
               .then(token=>setClientToken(token))
               .catch(error=>console.log(error))
               
          }
          
          fetchMyAPI()
         // console.log(clientToken)
        /*(async () => {
            await fetch(API_HOST+"/pm/clientToken").then(resp=>resp.json()
            ).then(res=>console.log(res))
           // setClientToken(response?.client_token || response?.clientToken);
        })();*/
    }, []);

    return (
        
        <>
            {console.log(clientToken)}
            {clientToken ? (
                <div style={{ maxWidth: "750px", minHeight: "200px" }}>
                    <PayPalScriptProvider
                        options={{
                            "client-id": "Acg1h5a8GOXi_jJqKfnP3xbTs951naCsAUow0NN7ShPDwUc1u9_FffgxodBa5KV8pwlI3ZwLLZAqFKl-",
                            components: "buttons",
                            // "data-user-id-token": "your-tokenization-key-here",
                            "data-client-token": clientToken,
                            intent: "tokenize",
                            vault: true,
                        }}
                        >
                        <BraintreePayPalButtons
                            style={style}
                            disabled={false}
                            fundingSource="paypal" // Available values are: ["paypal", "card", "credit", "paylater", "venmo"]
                            forceReRender={[style]}
                            createBillingAgreement={function (data, actions) {
                                return actions.braintree.createPayment({
                                    // Required
                                    flow: "vault"
                    
                                    // The following are optional params
                                  //  billingAgreementDescription:
                                    //    "Your agreement description",
                                    //enableShippingAddress: false,
                                   /* shippingAddressEditable: false,
                                    shippingAddressOverride: {
                                        recipientName: "Scruff McGruff",
                                        line1: "1234 Main St.",
                                        line2: "Unit 1",
                                        city: "Chicago",
                                        countryCode: "US",
                                        postalCode: "60652",
                                        state: "IL",
                                        phone: "123.456.7890",
                                    },*/
                                });
                            }}
                            onApprove={function (data, actions) {
                                return actions.braintree
                                    .tokenizePayment(data)
                                    .then((payload) => {
                                        // Your code here after capture the order
                                        console.log(JSON.stringify(payload));
                                        fetch(API_HOST+"/customer/create/"+payload,{headers : { 
                                            'Content-Type': 'application/json',
                                            'Accept': 'application/json'
                                           }})
                                           .then(resp=>resp.text())
                                           .then(custId=>setCustomerId(custId))
                                           .catch(error=>console.log(error))
                                       
                                    });
                                }
                            }
                        />
                    </PayPalScriptProvider>
                </div>
            ) : (
                <h1>Loading token...</h1>
            )}
        </>
    );
}